import {InsuranceCompany} from './insuranceCompany';
import {AddressModel} from './address.model';
import {AssistanceTypeEnum} from './assistanceTypeEnum';
import {PersonModel} from './person.model';
import {IncidentCauseCodeEnum} from './incidentCauseCodeEnum';
import {FlowTypeEnum} from './flowTypeEnum';

export class CasedataModel {

  assistanceType?: AssistanceTypeEnum;
  caseDescription?: {[key: string]: string} = {};
  flowType?: FlowTypeEnum;
  inquiryType?: string;
  diagnosesName?: string; // this should not be mapped to the backend
  insuranceCompany?: InsuranceCompany;
  creditCardCompany?: InsuranceCompany;
  travelpurpose?: string[] = new Array<string>();
  incidentCauseCode?: IncidentCauseCodeEnum;
  creditCard?: boolean;

  departureDate?: string;
  returnDate?: string;
  accidentDateRadio?: string;
  accidentDate?: string;

  addressCurrent?: AddressModel = new AddressModel();
  addressIncident?: AddressModel = new AddressModel();

  reporter?: PersonModel = new PersonModel();
  policyOwner?: PersonModel = new PersonModel();
  child?: PersonModel = undefined;

  supplierProfileCode?: string;
  supplierName?: string;

  constructor() {
  }
}

export enum CaseSessionData{
  SHOW_KEYS = 'showKeys'
}
